import { useEffect, useState, useRef, useCallback, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Image, Typography, Row, Col } from 'antd';
import type { InputRef } from 'antd';
import { UserMigrationDetails } from 'all-in-one-shared-api/dist/apis/user/usePatchExistingUser';
import generateKey from 'utils/generateKey';
import { useInterval } from 'hooks/useInterval';
// import mobileIcon from 'assets/images/mobile-icon.svg';
import mobileIcon from 'assets/images/neutral-1.svg';
import emailIcon from 'assets/images/Group 3.svg';
import { ActionType, RegistrationFlowContext } from 'contexts/registration';
import {
  Card,
  // Container,
  InvalidTextMsg,
  // OtpInputField,
  ResendCaptchaSection,
  SubTitle,
  // OtpInputContainer,
  // OtpInputWrapper,
  // OtpInput,
  NewInput,
} from './styledComponents';
import { getConfig } from 'configs';
// import { SessionStorageKey, sessionStorageService } from '../../../../utils/SessionStorageService';
// import { useRegistrationStateQuery } from '../../../../hooks/useRegistrationStateQuery';
import GoogleCaptcha from '../../../../components/googleCaptcha';
// import { getBirthdayString } from 'utils/registration';
// import { useKeycloakReady } from 'hooks';
import {
  // ApiFetcherError,
  // useRequestOtp,
  useValidateOtp,
  // useEmailOtp,
  useEmailOtpValidate,
  useValidateInfo,
  // useUserRegister,
  // useLifeUserRegister,
  // useRegister,
  // usePatchExistingUser,
} from 'all-in-one-shared-api';
import { setErrorCodeFun } from 'utils/setErrorCodeFun/setErrorCodeFun';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
const { Title, Text, Link } = Typography;

const RESEND_COUNTDOWN_PERIOD = 60;

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

interface LocationState extends UserMigrationDetails {
  prevPath?: string;
  saveTodb?: boolean;
  email?: string;
  type?: string;
}

export const LifeForgetOtpVerificationPage = (): JSX.Element => {
  const initialValues = useRegistrationStateQuery();
  // const [resendCountdown, setResendCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  // const [otpArray, setOtpArray] = useState(['', '', '', '', '', '']);
  const [otpArray, setOtpArray] = useState('');
  const [isAllowEdit, setIsAllowEdit] = useState(false);
  // const { token } = useKeycloakReady();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // const registrationState = useRegistrationStateQuery();
  // const [otpInput, setOtpInput] = useState("");
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [requestOtpCount, setRequestOtpCount] = useState(0);
  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  // const [disabledVerification, setDisabledVerification] = useState(false);
  const { state, dispatch } = useContext(RegistrationFlowContext);
  const location = useLocation();
  const { loginId, mobile, email, countryCode, type } = (location.state as LocationState) ?? {};

  // Note(Anson Kan): assuming `mobile` exists for the current user
  // const mobileNumber = (countryCode ?? '') + (mobile ?? '');
  const [key, setKey] = useState<string>('');
  const [validateKey, setValidateKey] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [showTips, setShowTips] = useState(false);

  const {
    shouldFetch: shouldValidateFetch,
    // data: forgotPasswordWithLoginData,
  } = useValidateInfo(
    key,
    state.selfDefinedLoginId || initialValues.selfDefinedLoginId || '',
    email ? state.email : '',
    mobile ? state.mobile : '',
    mobile ? state.countryCode : '',
    'Y',
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      onSuccess: () => {
        shouldValidateFetch(false);
        setError(null);
      },
      onError: (error) => {
        if (error) {
          shouldValidateFetch(false);
          // const apiError = error as ApiFetcherError;
          // setErrorMsg(apiError.code ? apiError.code : error.message);
          setError(error.code);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );
  const { shouldFetch: shouldEmailValidate /*, isLoading: isValidating */ } = useEmailOtpValidate(
    validateKey,
    loginId || initialValues.selfDefinedLoginId || '',
    otpArray,
    {
      shouldRetryOnError: false,
      onSuccess: (validateResponse) => {
        shouldEmailValidate(false);
        if (validateResponse) {
          if (validateResponse.success) {
            setErrorMsg(null);
            setError(null);

            console.log('validateResponse', validateResponse);
            navigate('/forgot/ForgotPasswordReset', {
              replace: true,
              state: {
                otpCode: otpArray,
              },
            });
          } else {
            //光標移入第一個輸入框
            if (digit1InputRef.current) {
              digit1InputRef.current.focus();
            } else {
              console.error('digit1InputRef.current is null');
            }
            setOtpArray('');
            setErrorMsg(validateResponse.message);
            setError(null);
          }
        }
      },
      onError: (error) => {
        if (error) {
          shouldEmailValidate(false);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
          setError(null);
        }
      },
    },
  );

  const { shouldFetch: shouldValidateOtp } = useValidateOtp(
    validateKey,
    loginId || initialValues.selfDefinedLoginId || '',
    otpArray,
    {
      shouldRetryOnError: false,
      onSuccess: (validateResponse) => {
        shouldValidateOtp(false);
        if (validateResponse) {
          if (validateResponse.success) {
            setErrorMsg(null);
            setError(null);

            navigate('/forgot/ForgotPasswordReset', {
              replace: true,
              state: {
                otpCode: otpArray,
              },
            });
            // shouldLifeRegister(true);
          } else {
            //光標移入第一個輸入框
            if (digit1InputRef.current) {
              digit1InputRef.current.focus();
            } else {
              console.error('digit1InputRef.current is null');
            }
            setOtpArray('');
            setError(null);
            setErrorMsg(validateResponse.message);
          }
        }
      },
      onError: (error) => {
        if (error) {
          shouldValidateOtp(false);
          setError(null);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );

  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown >= 0 ? 1000 : null,
  );
  const digit1InputRef = useRef<InputRef>(null);

  const handleResendOtp = () => {
    if (!showTips) setShowTips(true);

    if (requestOtpCount < 3) {
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }

    // setOtpInput("");
    setRequestOtpCount(requestOtpCount + 1);
    console.log('onPressResend()->');
    setKey(generateKey());

    setOtpArray('');
    setError(null);
    setErrorMsg('life.register.resendOtp');
    if (digit1InputRef.current) {
      digit1InputRef.current.focus();
    }

    // setResendCountdown(RESEND_COUNTDOWN_PERIOD);
    // startResendCountdown();
    // if (email) {
    //   shouldEmailFetch(true);
    // } else if (mobile) {
    //   shouldFetch(true);
    // }
    shouldValidateFetch(true);
  };

  // useEffect(() => {
  //   startResendCountdown();

  //   return () => {
  //     if (resendCountdownIntervalID) {
  //       clearInterval(resendCountdownIntervalID);
  //     }
  //   };
  // }, [resendCountdownIntervalID, startResendCountdown]);
  useEffect(() => {
    if (requestOtpCount >= 3) {
      setIsShowCaptcha(true);
    }
  }, [requestOtpCount, setIsShowCaptcha]);
  useEffect(() => {
    if (error) {
      const errorMessage = setErrorCodeFun(error, i18n.language);
      setErrorMsg(errorMessage);
    }
  }, [error, i18n.language]);
  const handleVerifyOtp = useCallback(() => {
    if (!/\d{6}/.test(otpArray)) {
      setError(null);
      setErrorMsg(t('smsOtpVerification.code-not-found'));
      return;
    }

    setValidateKey(generateKey());
    if (email) {
      shouldEmailValidate(true);
    } else if (mobile) {
      shouldValidateOtp(true);
    }

    // mutateVerifyOtp();
  }, [otpArray, email, mobile, setErrorMsg, setValidateKey, shouldEmailValidate, shouldValidateOtp, t]);
  useEffect(() => {
    if (otpArray.length === 6) {
      handleVerifyOtp();
    }
  }, [otpArray, handleVerifyOtp]);
  useEffect(() => {
    if (errorMsg && errorMsg == 'smsOtpVerification.retry-limit-exceeded') {
      setIsAllowEdit(true);

      // setCountdown(30);
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
  }, [errorMsg]);
  useEffect(() => {
    if (countdown === 0) {
      setIsAllowEdit(false);
    }
  }, [countdown]);

  const onCaptchaSuccess = () => {
    setIsShowCaptcha(false);
  };

  const onCaptchaError = () => {
    setError(null);
    setErrorMsg(t('login.error.captchaDigitError'));
  };
  const onOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    setOtpArray(e.target.value);
    setError(null);
    setErrorMsg(null);
  };
  function maskEmail(email: string) {
    if (!email) return '';
    // ???????????????
    const [username, domain] = email.split('@');
    // const [domains, coms,countrys] = domain.split('.');
    const domainList = domain.split('.');

    // ???????,???1???1?,???*??
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    if (domainList.length > 2) {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    } else {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    }
    // ??????????
  }
  function maskPhoneNumber(phoneNumber: string) {
    if (!phoneNumber) return '';
    // ???3???4?,???*??
    const visibleDigits = 2; // ????,??????????
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);

    // ?????*?????
    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);

    // ??????????
    return startDigits + maskedPart + endDigits;
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        paddingLeft: '40px',
        paddingRight: '40px',
      }}
    >
      {/* <img src={forgotIcon} alt="forgot-icon" style={{ marginBottom: 12 }} /> */}
      <Typography.Title
        level={3}
        style={{ fontSize: '33px', fontFamily: 'Roboto400', color: '#fff', fontWeight: '400' }}
      >
        {t('life.forgetLoginId.ForgotPassword')}{' '}
      </Typography.Title>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
        }}
      >
        <Card style={{ border: 0, width: '100%' }}>
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <Space align="center" direction="vertical"> */}
              <Title level={3}>{t('smsOtpVerification.screenTitle')}</Title>
            </Col>
            {!email && showTips && (
              <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                <Title level={3} style={{ fontSize: '20px', color: 'red' }}>
                  {type == 'eb' ? t('sms.othersOtpEb') : t('sms.othersOtpLife')}
                </Title>
              </Col>
            )}
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Image height="176px" src={email ? emailIcon : mobileIcon} preview={false} />
              {/* </Space> */}
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <SubTitle
                style={{ display: 'inline-block', textAlign: 'center', fontSize: '20px', fontFamily: 'Roboto400' }}
              >
                {email ? t('smsOtpVerification.emailScreenSubtitle') : t('smsOtpVerification.mobileScreenSubtitle')}
                <br />
                {email ? maskEmail(email) : mobile ? countryCode + '  ' + maskPhoneNumber(mobile) : null}
              </SubTitle>
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <OtpInputContainer>
                {[digit1InputRef, digit2InputRef, digit3InputRef, digit4InputRef, digit5InputRef, digit6InputRef].map(
                  (textInputRef, index) => (
                    <OtpInputWrapper key={index}>
                      <input
                        style={{
                          width: '40px',
                          height: '40px',
                          textAlign: 'center',
                          fontSize: '20px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                        }}
                        type="text"
                        maxLength={1}
                        value={otpArray[index]}
                        onKeyPress={onOtpKeyPress(index)}
                        onChange={onOtpChange(index)}
                        className="single-digit-input"
                        autoFocus={index === 0}
                        ref={textInputRef}
                        disabled={isAllowEdit}
                      />
                    </OtpInputWrapper>
                  ),
                )}
              </OtpInputContainer> */}
              <NewInput
                maxLength={6}
                value={otpArray}
                onChange={onOtpChange}
                className="single-digit-input"
                autoFocus
                ref={digit1InputRef}
                disabled={isAllowEdit}
              />
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {errorMsg && <InvalidTextMsg type="danger">{t(errorMsg)}</InvalidTextMsg>}
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <ResendCaptchaSection>
                {isShowCaptcha ? (
                  <GoogleCaptcha
                    hl={i18n.language}
                    sitekey={config.captchaSiteKey}
                    onChange={onCaptchaSuccess}
                    onError={onCaptchaError}
                    onExpired={onCaptchaError}
                  />
                ) : (
                  <>
                    <Link
                      onClick={countdown > 0 ? (e) => e.preventDefault() : handleResendOtp}
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        pointerEvents: countdown > 0 ? 'none' : 'auto',
                        color: countdown > 0 ? 'gray' : '#752127', // 设置禁用时颜色为灰色
                      }}
                    >
                      {t('smsOtpVerification.resend')}
                    </Link>
                    {countdown >= 0 && (
                      <Text type="secondary">
                        {t('smsOtpVerification.resendCountdownText', {
                          second: countdown,
                        })}
                      </Text>
                    )}
                  </>
                )}
              </ResendCaptchaSection>
            </Col>

            {/* <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%' }}>
                <Button block type="primary" disabled={disabledVerification} size="large" onClick={handleVerifyOtp}>
                  {t('common.submit')}
                </Button>
              </div>
            </Col> */}
            <Link
              onClick={() => {
                dispatch({ type: ActionType.ClearForm });
                navigate('/login');
              }}
              style={{
                fontSize: '17px',
                fontFamily: 'Roboto400',
                marginLeft: 4,
                marginRight: 4,
                color: '#C21B17',
                textDecoration: 'underline',
              }}
            >
              {t('common.backToLogin')}
            </Link>
          </Row>
        </Card>
      </div>
    </div>
  );
};
